import { useAxios } from "auth-sdk";
import { useMemo } from "react";
import { uploadManagerHookFactory } from "shared-utils";

import {
  BANK_STATEMENTS_CONFIRM_UPLOAD_API,
  BANK_STATEMENTS_CREATE_UPLOAD_API,
  BANK_STATEMENTS_DELETE_UPLOAD_API,
  UPLOAD_STATEMENTS_SIZE_LIMIT_MB,
  UPLOAD_STATEMENTS_SUPPORTED_EXTENSIONS,
} from "../../constants";
import type { BankStatementUploadFile } from "../types/bank-statements";

export const useBankStatementUploadManager = (customerDomain: string) => {
  const client = useAxios();
  const requestFn = useMemo(
    () => (url: RequestInfo, body: any) => client.post(url.toString(), body).then((r) => r.data),
    [client]
  );

  const useDocumentUpload = useMemo(
    () =>
      uploadManagerHookFactory<BankStatementUploadFile>({
        createUrlPath: BANK_STATEMENTS_CREATE_UPLOAD_API.replace(":customerSlug", customerDomain),
        confirmUploadPath: BANK_STATEMENTS_CONFIRM_UPLOAD_API.replace(":customerSlug", customerDomain),
        deleteUploadPath: BANK_STATEMENTS_DELETE_UPLOAD_API.replace(":customerSlug", customerDomain),
        files: [],
        supportedFileExtensions: UPLOAD_STATEMENTS_SUPPORTED_EXTENSIONS,
        sizeLimitMB: UPLOAD_STATEMENTS_SIZE_LIMIT_MB,
        requestFn,
      }),
    [customerDomain, requestFn]
  );

  return useDocumentUpload;
};
